import { useMemo } from 'react';
import useWindowSize from '../../Common/_hooks/useWindowSize';
import usePreviewSize from './usePreviewSize';
import { useTheme } from '@mui/material';
import { useSearchParams } from 'react-router';

const DESKTOP_HEADER_HEIGHT = 64;
const MOBILE_HEADER_HEIGHT = 52;
const MOBILE_HEADER_WITH_SELECTOR_HEIGHT = 92;
const SCENE_SELECTOR_HEIGHT = 55;
const LAYER_LIST_WIDTH = 275;
const LAYER_LIST_HEIGHT = 246;

export default function useStageDimensions() {
    const windowSize = useWindowSize();
    const previewSize = usePreviewSize();
    const theme = useTheme();
    const [searchParams] = useSearchParams();
    const isEditing = searchParams.has('design');

    const stageSize = useMemo(() => {
        const headerHeight = windowSize.width < theme.breakpoints.values.md
            ? (isEditing ? MOBILE_HEADER_HEIGHT : MOBILE_HEADER_WITH_SELECTOR_HEIGHT)
            : DESKTOP_HEADER_HEIGHT;
        let stageWidth = windowSize.width - previewSize.width - LAYER_LIST_WIDTH;
        let stageHeight = windowSize.height - headerHeight - SCENE_SELECTOR_HEIGHT; //windowHeight - headerHeight - sceneSelectorHeight

        if(windowSize.width <= theme.breakpoints.values.lab_mobile && windowSize.height >= theme.height_breakpoints.values.lab_mobile ||
            windowSize.width <= 953 && windowSize.height <= 1070
        ) {
            stageWidth = windowSize.width;
            stageHeight = windowSize.height - headerHeight - LAYER_LIST_HEIGHT - SCENE_SELECTOR_HEIGHT;
        }

        else if(windowSize.width <= 1510 && windowSize.height >= theme.height_breakpoints.values.lab_mobile) {
            stageWidth = windowSize.width - previewSize.width - 15;
            stageHeight = windowSize.height - headerHeight - LAYER_LIST_HEIGHT - SCENE_SELECTOR_HEIGHT;
        }

        else if(windowSize.width <= 1510) {
            stageWidth = windowSize.width - LAYER_LIST_WIDTH - 30;

            /*if(windowSize.height < theme.height_breakpoints.values.lab_mobile) {
                stageWidth = windowSize.width - 30;
                stageHeight = windowSize.height - HEADER_HEIGHT - LAYER_LIST_HEIGHT - SCENE_SELECTOR_HEIGHT;
            }*/
        } else if(windowSize.height <= theme.height_breakpoints.values.lab_mobile) {
            stageWidth = windowSize.width - LAYER_LIST_WIDTH - 15;
        } else if(windowSize.height <= 1070) {
            const leftOverSpace = windowSize.width - LAYER_LIST_WIDTH;
            stageWidth = Math.min(leftOverSpace*0.6, stageWidth);
        }

        return {
            stageWidth, stageHeight
        }
    }, [isEditing, previewSize, theme, windowSize])

    return stageSize;
}
